import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Compass, Flag, ShipWheel } from "lucide-react";
import { getLearningArticleTitle } from "@/i18n";
import { getPublicComponentCopy } from "@/lib/publicComponentCopy";
import { localizedLearningArticleUrl } from "@/lib/learningUrls";

export default function LearningPathCards({ articles = [], prefix = "/en", topicSlug = "", lang = "en" }) {
  if (!articles.length) return null;

  const labels = getPublicComponentCopy(lang).learning.path;
  const cards = [
    { label: labels[0][0], note: labels[0][1], icon: Flag, article: articles[0] },
    { label: labels[1][0], note: labels[1][1], icon: Compass, article: articles[1] || articles[0] },
    { label: labels[2][0], note: labels[2][1], icon: ShipWheel, article: articles.find((article) => article.difficulty_level === "advanced" || article.difficulty_level === "expert") || articles[articles.length - 1] },
  ];

  return (
    <div className="mt-6 grid gap-4 md:grid-cols-3">
      {cards.map(({ label, note, icon: Icon, article }) => (
        <Link
          key={`${label}-${article.slug}`}
          to={localizedLearningArticleUrl({ lang, category: topicSlug, article })}
          className="group rounded-[1.5rem] border border-[#BFDADC] bg-white/92 p-5 shadow-[0_12px_28px_rgba(8,22,51,0.07)] transition hover:-translate-y-0.5 hover:border-[#17A6A4] hover:bg-white"
        >
          <div className="flex items-center justify-between gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#17A6A4]/10 text-[#168F92]"><Icon className="h-5 w-5" /></span>
            <ArrowRight className="h-4 w-4 text-[#168F92] transition group-hover:translate-x-1" />
          </div>
          <p className="mt-4 text-xs font-black uppercase tracking-[0.22em] text-[#168F92]">{label}</p>
          <h3 className="mt-2 line-clamp-2 text-lg font-black leading-tight text-[#081633]">{getLearningArticleTitle(article.title, lang, article.slug)}</h3>
          <p className="mt-2 text-sm font-semibold text-[#10233E]/70">{note}</p>
        </Link>
      ))}
    </div>
  );
}